var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "checkout__address-wrapper" }, [
    (!_vm.isAddressListEmpty &&
      _vm.selectedAddress &&
      _vm.addressType !== "2") ||
    (_vm.addressType === "2" && _vm.deliveryAddressId !== -99)
      ? _c(
          "div",
          { staticClass: "checkout__address-complete" },
          [
            _vm.deliveryAddressId === -99 && _vm.addressType === "1"
              ? [
                  _c(
                    "span",
                    {
                      staticClass: "d-inline-block",
                      class: { "mb-3": _vm.isBillingAddressVisible },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$translate(
                              "OD3dprimaV2::Template.billingAndShipping"
                            )
                          ) +
                          "\n            "
                      ),
                    ]
                  ),
                ]
              : [
                  _vm.addressType === "1"
                    ? [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.$translate(
                                "OD3dprimaV2::Template.billingAddress"
                              )
                            ) +
                            "\n            "
                        ),
                      ]
                    : _vm.addressType === "2" && _vm.deliveryAddressId !== -99
                    ? [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.$translate(
                                "OD3dprimaV2::Template.shippingAddress"
                              )
                            ) +
                            "\n            "
                        ),
                      ]
                    : _vm._e(),
                ],
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.showAddressForm
      ? _c(
          "div",
          { staticClass: "cmp cmp-address-list checkout__address-summary" },
          [
            _c("div", { staticClass: "dropdown items" }, [
              _c(
                "div",
                {
                  class: {
                    "items items-empty":
                      _vm.isAddressListEmpty &&
                      _vm.addressType === "2" &&
                      _vm.addressList.length === 1,
                    "is-loading disabled":
                      _vm.isBasketLoading || _vm.isCheckoutReadonly,
                  },
                  attrs: { id: "addressMultiSelect" + _vm._uid },
                },
                [
                  !_vm.isAddressListEmpty &&
                  _vm.selectedAddress &&
                  _vm.selectedAddress.id !== -99
                    ? _c(
                        "div",
                        {
                          staticClass: "item-inner",
                          class: { error: _vm.showError },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "item-content" },
                            [
                              _c("address-header-checkout", {
                                class: _vm.paddingClasses,
                                style: _vm.paddingInlineStyles,
                                attrs: { address: _vm.selectedAddress },
                              }),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _vm.addressType === "1"
                ? _c(
                    "div",
                    {
                      staticClass:
                        "btn btn-secondary btn-secondary--no-shadow btn-block card",
                      class: {
                        "mt-5":
                          this.isBillingAddressVisible &&
                          this.isAddAddressEnabled,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.showEditAddress(_vm.selectedAddress)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$translate(
                              "OD3dprimaV2::Template.addressChange"
                            )
                          ) +
                          "\n            "
                      ),
                    ]
                  )
                : _c(
                    "div",
                    {
                      staticClass:
                        "btn btn-secondary btn-secondary--no-shadow btn-block",
                      class: {
                        "dropdown-toggle card": _vm.isAddAddressEnabled,
                        "d-none": !_vm.isShippingVisible,
                        "mt-5":
                          this.isBillingAddressVisible &&
                          this.isAddAddressEnabled,
                      },
                      attrs: {
                        "data-toggle": "dropdown",
                        "aria-haspopup": "true",
                        "aria-expanded": "false",
                        "data-boundary": "window",
                        "data-flip": "false",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.onDropdownClicked($event)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            (_vm.deliveryAddressId === -99) &
                              (_vm.addressType === "2")
                              ? _vm.$translate(
                                  "OD3dprimaV2::Template.addressDifferent"
                                )
                              : _vm.$translate(
                                  "OD3dprimaV2::Template.addressChange"
                                )
                          ) +
                          "\n            "
                      ),
                    ]
                  ),
              _vm._v(" "),
              _vm.isAddAddressEnabled && _vm.addressType !== "1"
                ? _c(
                    "div",
                    {
                      ref: "addressDropdown",
                      staticClass: "dropdown-menu",
                      attrs: {
                        "aria-labelledby": "addressMultiSelect" + _vm._uid,
                      },
                    },
                    [
                      _c(
                        "ul",
                        _vm._l(_vm.addressList, function (address, index) {
                          return _c("li", { staticClass: "item" }, [
                            _c("input", {
                              attrs: {
                                type: "radio",
                                name: "shippingAddress" + _vm._uid,
                                id: "addressSelectItem" + _vm._uid + address.id,
                              },
                              domProps: {
                                value: address.id,
                                checked:
                                  _vm.selectedAddress &&
                                  _vm.selectedAddress.id === address.id,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.onAddressChanged(address)
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "item-inner",
                                attrs: {
                                  for:
                                    "addressSelectItem" + _vm._uid + address.id,
                                },
                              },
                              [
                                address.id == -99
                                  ? _c("span", [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "text-muted small font-italic pt-3",
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                _vm.$translate(
                                                  "Ceres::Template.addressSameAsInvoice"
                                                )
                                              ) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                    ])
                                  : _c(
                                      "span",
                                      { staticClass: "item-content small" },
                                      [
                                        _c("address-header-checkout", {
                                          class: _vm.paddingClasses,
                                          style: _vm.paddingInlineStyles,
                                          attrs: { address: address },
                                        }),
                                      ],
                                      1
                                    ),
                                _vm._v(" "),
                                address.id != -99
                                  ? _c(
                                      "div",
                                      { staticClass: "item-controls" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "item-edit" },
                                          [
                                            _c(
                                              "button",
                                              {
                                                directives: [
                                                  {
                                                    name: "tooltip",
                                                    rawName: "v-tooltip",
                                                  },
                                                ],
                                                staticClass:
                                                  "btn btn-primary btn-appearance",
                                                attrs: {
                                                  "data-toggle": "tooltip",
                                                  "data-placement": "top",
                                                  title: _vm.$translate(
                                                    "Ceres::Template.addressEdit"
                                                  ),
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    $event.preventDefault()
                                                    return _vm.showEditAddress(
                                                      address
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-pencil-square-o",
                                                  attrs: {
                                                    "aria-hidden": "true",
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "item-remove" },
                                          [
                                            _c(
                                              "button",
                                              {
                                                directives: [
                                                  {
                                                    name: "tooltip",
                                                    rawName: "v-tooltip",
                                                  },
                                                ],
                                                staticClass: "btn btn-danger",
                                                attrs: {
                                                  "data-toggle": "tooltip",
                                                  "data-placement": "top",
                                                  title: _vm.$translate(
                                                    "Ceres::Template.addressDelete"
                                                  ),
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    $event.preventDefault()
                                                    return _vm.showDeleteModal(
                                                      address
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "fa fa-times",
                                                  attrs: {
                                                    "aria-hidden": "true",
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ])
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _vm.addressType === "2"
                        ? _c("div", { staticClass: "text-center" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary btn-appearance",
                                attrs: {
                                  disabled:
                                    _vm.isBasketLoading ||
                                    _vm.isCheckoutReadonly,
                                },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.showAddAddress()
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.addressAddAddress"
                                      )
                                    ) +
                                    "\n                    "
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
            ]),
          ]
        )
      : _c(
          "fieldset",
          { ref: "addressModal" },
          [
            _vm.addressType === "2"
              ? _c("h5", { staticClass: "checkout__column-sub-title mt-3" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.$translate("OD3dprimaV2::Template.shippingAddress")
                      ) +
                      "\n        "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("create-update-address-checkout", {
              attrs: {
                "address-data": _vm.addressToEdit,
                "modal-type": _vm.modalType,
                "address-type": _vm.addressType,
                "optional-address-fields": _vm.optionalAddressFields,
                "required-address-fields": _vm.requiredAddressFields,
                "default-salutation": _vm.defaultSalutation,
                "is-billing-address-visible": _vm.isBillingAddressVisible,
                "is-delivery-address-visible": _vm.isDeliveryAddressVisible,
              },
              on: {
                input: function ($event) {
                  return _vm.setAddressToEditField($event)
                },
                saved: _vm.closeAddress,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "custom-address-fields",
                    fn: function () {
                      return [_vm._t("custom-address-fields")]
                    },
                    proxy: true,
                  },
                ],
                null,
                true
              ),
            }),
          ],
          1
        ),
    _vm._v(" "),
    _c("div", { ref: "deleteModal" }, [
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: { tabindex: "-1", role: "dialog" },
        },
        [
          _c(
            "div",
            { staticClass: "modal-dialog", attrs: { role: "document" } },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("h4", { staticClass: "modal-title" }, [
                    _vm._v(
                      "\n                            " +
                        _vm._s(
                          _vm.$translate(
                            "Ceres::Template.addressShippingAddressDelete"
                          )
                        ) +
                        "\n                        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: { type: "button", "aria-label": "Close" },
                      on: { click: _vm.closeDeleteModal },
                    },
                    [
                      _c("span", { attrs: { "aria-hidden": "true" } }, [
                        _vm._v("×"),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("fieldset", [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-sm-12" }, [
                        _c("div", { staticClass: "modal-address" }, [
                          _vm.addressToDelete.name1 &&
                          _vm.addressToDelete.name1.length > 0
                            ? _c("strong", [
                                _vm._v(
                                  "\n                                            " +
                                    _vm._s(_vm.addressToDelete.name1) +
                                    "\n                                        "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.addressToDelete.name1 ||
                          _vm.addressToDelete.name1.length == 0
                            ? _c("strong", [
                                _vm._v(
                                  "\n                                            " +
                                    _vm._s(
                                      _vm._f("optionType")(
                                        _vm.addressToDelete,
                                        11
                                      )
                                    ) +
                                    " " +
                                    _vm._s(_vm.addressToDelete.name2) +
                                    " " +
                                    _vm._s(_vm.addressToDelete.name3) +
                                    "\n                                        "
                                ),
                              ])
                            : _c("span", [
                                _vm._v(
                                  "\n                                            " +
                                    _vm._s(
                                      _vm._f("optionType")(
                                        _vm.selectedAddress,
                                        11
                                      )
                                    ) +
                                    " " +
                                    _vm._s(_vm.addressToDelete.name2) +
                                    " " +
                                    _vm._s(_vm.addressToDelete.name3) +
                                    "\n                                        "
                                ),
                              ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              "\n                                            " +
                                _vm._s(_vm.addressToDelete.name4) +
                                "\n                                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              "\n                                            " +
                                _vm._s(_vm.addressToDelete.address1) +
                                " " +
                                _vm._s(_vm.addressToDelete.address2) +
                                "\n                                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            [
                              _vm.addressToDelete.address1 === "PACKSTATION" ||
                              _vm.addressToDelete.address1 === "POSTFILIALE"
                                ? [
                                    _vm._v(
                                      "\n                                                " +
                                        _vm._s(
                                          _vm.$translate(
                                            "Ceres::Template.addressPostNummer"
                                          )
                                        ) +
                                        "\n                                                " +
                                        _vm._s(
                                          _vm._f("optionType")(
                                            _vm.addressToDelete,
                                            6
                                          )
                                        ) +
                                        "\n                                            "
                                    ),
                                  ]
                                : _vm._e(),
                              _vm._v(
                                "\n                                            " +
                                  _vm._s(_vm.addressToDelete.address3) +
                                  "\n                                        "
                              ),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              "\n                                            " +
                                _vm._s(_vm.addressToDelete.postalCode) +
                                " " +
                                _vm._s(_vm.addressToDelete.town) +
                                "\n                                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              "\n                                            " +
                                _vm._s(
                                  _vm.getCountryName(
                                    _vm.addressToDelete.countryId
                                  )
                                ) +
                                "\n                                        "
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-medium mr-2 btn-outline-primary",
                      attrs: { type: "button" },
                      on: { click: _vm.closeDeleteModal },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$translate("Ceres::Template.addressCancel")
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("i", {
                        staticClass: "fa fa-times",
                        attrs: { "aria-hidden": "true" },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-appearance btn-medium",
                      attrs: {
                        type: "button",
                        disabled: _vm.deleteModalWaiting,
                      },
                      on: { click: _vm.deleteAddress },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$translate("Ceres::Template.addressDelete")
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("icon", {
                        attrs: {
                          icon: "trash",
                          loading: _vm.deleteModalWaiting,
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
            ]
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }